import React from 'react'
import { Box } from '@mui/material'

interface FormTabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
  idPrefix?: string
}

/**
 * Shared TabPanel component for forms with tabs
 * 
 * @param children - The content to display in the tab panel
 * @param index - The index of this tab panel
 * @param value - The currently active tab index
 * @param idPrefix - Optional prefix for the panel ID (defaults to 'form')
 */
export const FormTabPanel: React.FC<FormTabPanelProps> = ({ 
  children, 
  value, 
  index, 
  idPrefix = 'form',
  ...other 
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-tabpanel-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 2 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

export default FormTabPanel